/* cellFormatters.js */

"use strict";

exports.dateFormatter =  function dateFormatter (row, cell, value) {
    if (+value === -1) {
        return "Unlimited";
    }

    if (!value || !Number.isInteger(value)) {
        return value;
    }
    return new Date(value).toLocaleString( undefined, {
        timeZone: "UTC",
        month: "2-digit",
        day:"2-digit",
        year: "numeric"
    });
};

//make numbers thousand delimited: 5,000
exports.numberFormatter = function numberFormatter (row, cell, value) {
    if (value === "" || value === undefined || Number.isNaN(value)) {
        value = "-";
    }
    return isNaN(value) ? value : parseInt(value, 10).toLocaleString();
};
